var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calculator-page"},[_c('calc-seo-intro',{attrs:{"path":"/calculators/payroll-deduction"}}),_c('healthcare-roi-calculator',{attrs:{"calculatorTitle":'Payroll Deduction ROI (Healthcare)'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }